// extracted by mini-css-extract-plugin
export default {"loading":"Loading_loading__K7Xi7","bounce":"Loading_bounce__F5vi8"};